/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_DisconnectedInputs */



/**
* | output |
* | --- |
* | "Disconnected" |
*
* @param {My_Integrations_DisconnectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_disconnected = /** @type {((inputs?: My_Integrations_DisconnectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_DisconnectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Getrennt")
	return /** @type {LocalizedString} */ ("Disconnected")
});